import React from "react";
import { Divider } from "@mui/material";

import Loading from "components/common/loading/Loading";
import { useGetReportBillingHistoryQuery } from "app/store/transmission/api/transmissionDetailApi";

import { formatDateTime } from "utils/date";
import { isValidArray } from "utils/array";

const BillingInfo = ({ reportId }) => {
  const {
    data: billingHistory,
    isLoading,
    isFetching,
  } = useGetReportBillingHistoryQuery(reportId);

  return (
    <>
      <Divider />
      <div className="view-pdf__drawer--header">Billing Info</div>

      {isLoading || isFetching ? (
        <Loading height="50px" />
      ) : (
        <div className="view-pdf__drawer-billing--content">
          {!isValidArray(billingHistory) && (
            <div>No billing data available</div>
          )}

          {isValidArray(billingHistory) && (
            <div style={{ display: "table-row" }}>
              <div className="table-title">DATE</div>
              <div className="table-title">CODE</div>
              <div className="table-title">DIAGNOSIS CODE</div>
            </div>
          )}
          {isValidArray(billingHistory) &&
            [...billingHistory]?.map((item, index) => (
              <div key={`billing-${index}`} style={{ display: "table-row" }}>
                <div className="table-value" data-billingDate={`date-${index}`}>
                  {item?.billing_date
                    ? formatDateTime(item?.billing_date)
                    : "--"}
                </div>
                <div className="table-value" data-code={`code-${index}`}>
                  {item?.billing_code || "--"}
                </div>
                <div className="table-value" data-dcode={`dcode-${index}`}>
                  {item?.diagnosis_code || "--"}
                </div>
              </div>
            ))}
        </div>
      )}
    </>
  );
};

export default BillingInfo;
